import { ChangeEvent } from 'react'

import useWindowDimensions from '@/shared/hooks/useGetWindowSize'

const useOnInput = () => {
  const { width } = useWindowDimensions()
  const PhoneNum = (e: ChangeEvent<HTMLInputElement>) => {
    switch (true) {
      case width > 360 && e.target.value.length > 8:
        return (e.target.value = e.target.value.slice(0, 8))
      case width <= 360 && e.target.value.length > 11:
        return (e.target.value = e.target.value.slice(0, 11))
    }
  }
  const CertNum = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 4) {
      return (e.target.value = e.target.value.slice(0, 4))
    }
  }

  const SecurityNum = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 4) {
      return (e.target.value = e.target.value.slice(0, 4))
    }
  }
  const InquiryPhoneNum = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 11) {
      return (e.target.value = e.target.value.slice(0, 11))
    }
  }

  const InquiryName = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 10) {
      return (e.target.value = e.target.value.slice(0, 10))
    }
  }
  const InquiryTitle = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 50) {
      return (e.target.value = e.target.value.slice(0, 50))
    }
  }

  const InquiryEmail = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 30) {
      return (e.target.value = e.target.value.slice(0, 30))
    }
  }

  const RefundAccount = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 16) {
      return (e.target.value = e.target.value.slice(0, 16))
    }
  }

  return {
    PhoneNum,
    CertNum,
    InquiryPhoneNum,
    InquiryName,
    InquiryTitle,
    InquiryEmail,
    RefundAccount,
    SecurityNum,
  }
}

export default useOnInput
